import { observer } from "mobx-react";
import React from "react";
import { Table } from "react-bootstrap";

const specialKeys = ["command", "option"];

const SingleKey = ({ singleKey }) => {
  const lowerCaseKey = singleKey.toLowerCase();

  if (lowerCaseKey.length > 1 && specialKeys.includes(lowerCaseKey)) {
    return (
      <span className="shortcut-key">
        <i className={`fa-regular fa-${lowerCaseKey}`} />
      </span>
    );
  }
  return <span className="shortcut-key">{singleKey}</span>;
};

// https://stackoverflow.com/questions/31631430/javascript-get-strings-between-bracket
// https://stackoverflow.com/questions/55828533/split-string-on-sqaure-brackets-and-non-brackets
const KeyInstruction = ({ keyInstruction }) => {
  const bracketRegEx = /\[.+?\]/g;
  const structionArr = (keyInstruction || "")
    .split(/(\[[^\]]+\])/)
    .map((s) => s.trim())
    .filter(Boolean);

  return structionArr.map((str, index) =>
    bracketRegEx.test(str) ? (
      <SingleKey singleKey={str.slice(1, -1)} key={index} />
    ) : (
      <span key={index}>{str}</span>
    ),
  );
};

export const Shortcuts = observer(
  ({ shortcuts }) =>
    shortcuts?.length > 0 && (
      <div className="mb-4">
        <h5 className="fw-bold mb-3">Phím tắt cần nhớ</h5>
        <div className="border rounded-20 px-45 py-3">
          <Table className="m-0">
            <thead>
              <tr>
                <th className="pb-3">Mô tả</th>
                <th className="pb-3">Phím tắt</th>
              </tr>
            </thead>
            <tbody>
              {shortcuts?.map((shortcut) => (
                <tr className="py-2" key={shortcut.id}>
                  <td className="shortcut-text pt-4 pb-2 pe-3">{shortcut.name}</td>
                  <td className="shortcut-keys pt-4 pb-2">
                    <KeyInstruction keyInstruction={shortcut.keystrokes} />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    ),
);
